import React from 'react';
import { motion } from 'framer-motion';

function PricingSection() {
  const plans = [
    {
      name: "Trust-Based Plan",
      description: "Comprehensive trust-based estate planning for complete asset protection",
      features: [
        "Revocable Living Trust",
        "Pour-over Will",
        "Power of Attorney",
        "Healthcare Advance Directive",
        "Certificate of Trust",
        "Trust funding guidance"
      ],
      cta: "Get Started",
      popular: true
    },
    {
      name: "Will-Based Plan",
      description: "Essential will-based estate planning to protect your wishes",
      features: [
        "Last Will and Testament",
        "Power of Attorney",
        "Healthcare Advance Directive",
        "Digital document delivery",
        "Secure cloud storage"
      ],
      cta: "Get Started",
      popular: false
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50" id="pricing">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl font-serif text-primary-700 mb-4">
            Choose Your Plan
          </h2>
          <p className="text-lg text-secondary-600">
            Select the estate plan that fits your needs. Every plan includes attorney-reviewed documents and ongoing access.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {plans.map((plan, index) => (
            <motion.div
              key={plan.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`relative rounded-2xl shadow-xl overflow-hidden bg-white ${
                plan.popular ? 'ring-2 ring-primary-600' : ''
              }`}
            >
              {plan.popular && (
                <div className="absolute top-0 right-0 bg-primary-600 text-white px-4 py-1 text-sm font-semibold rounded-bl-lg">
                  Most Popular
                </div>
              )}

              <div className="p-8">
                <h3 className="text-2xl font-semibold mb-2 text-primary-700">
                  {plan.name}
                </h3>
                <p className="text-secondary-600 mb-6 min-h-[3rem]">
                  {plan.description}
                </p>

                <ul className="space-y-4 mb-8">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <svg
                        className="h-5 w-5 text-accent-500 mr-3 flex-shrink-0 mt-0.5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      <span className="text-secondary-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="p-8 bg-gray-50">
                <a
                  href="https://app.trustbuilder.law"
                  className={`block w-full py-3 px-6 rounded-lg font-medium transition-all duration-200 text-center ${
                    plan.popular
                      ? 'bg-primary-600 text-white hover:bg-primary-700'
                      : 'bg-white text-primary-600 border-2 border-primary-600 hover:bg-primary-50'
                  }`}
                >
                  {plan.cta}
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PricingSection;
